module.exports = __webpack_public_path__ + "static/media/siren-on.3b36b50a.svg";